<template>
  <div>
    <div class="grid-content maintitle">
      <span>用户积分消费记录</span>
    </div>

    <!-- 导表按钮 -->
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            size="medium"
            round
            @click="refresh"
            icon="el-icon-refresh"
          >
            刷新
          </el-button>
        </el-link>

        <el-link :underline="false">
          <el-button
            size="medium"
            round
            @click="downloadCsv"
            icon="el-icon-download"
          >
            导出
          </el-button>
        </el-link>
      </div>
      <el-divider></el-divider>
    </div>

    <!-- 检索区域 -->
    <div class="grid-content content-margin">
      <table class="simpleRow" style="width: 100%">
        <tr>
          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">流水号</span>
          </td>
          <td class="serachText">
            <el-input
              clearable
              v-model="pointFilterBody.consumeSerialNo"
              size="mini"
              placeholder="请输入"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">UserID</span>
          </td>
          <td class="serachText">
            <el-input
              style="float: left"
              clearable
              v-model="pointFilterBody.userID"
              size="mini"
              placeholder="请输入"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">OpenID</span>
          </td>
          <td class="serachText">
            <el-input
              clearable
              v-model="pointFilterBody.openID"
              size="mini"
              placeholder="请输入"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">UnionID</span>
          </td>
          <td class="serachText">
            <el-input
              clearable
              v-model="pointFilterBody.unionID"
              size="mini"
              placeholder="请输入"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">消费积分</span>
          </td>
          <td class="serachText">
            <el-input
              clearable
              v-model="pointFilterBody.point"
              size="mini"
              placeholder="请输入"
            />
          </td>
        </tr>
      </table>

      <table class="simpleRow" style="width: 100%">
        <tr>
          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">积分组</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="pointFilterBody.groupID"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in pointGroupList"
                :key="item.groupid"
                :label="item.name"
                :value="item.groupid"
              >
              </el-option>
            </el-select>
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">事件类型</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="pointFilterBody.eventID"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in eventTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">消费途径类型</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="pointFilterBody.consumeType"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in consumeTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>

          <td class="serachSpan">
          </td>
          <td class="serachText">
          </td>
          <td class="serachSpan">
          </td>
          <td class="serachText">
          </td>
        </tr>
      </table>

      <table class="simpleRow">
        <tr>
          <td style="width: 7%">
            <span class="simpleLabel" style="float: right">消费日期</span>
          </td>
          <td style="width: 13%">
            <el-select
              v-model="pointFilterBody.createDate.dateType"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="item in dateTypeOptions"
                :key="item.type"
                :label="item.label"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </td>

          <td
            v-if="pointFilterBody.createDate.dateType == 0"
            style="width: 30%"
          ></td>

          <td
            style="width: 15%"
            v-if="
              pointFilterBody.createDate.dateType == 1 ||
              pointFilterBody.createDate.dateType == 3 ||
              pointFilterBody.createDate.dateType == 4 ||
              pointFilterBody.createDate.dateType == 7
            "
          >
            <span v-if="pointFilterBody.createDate.dateType == 7">从</span>
            <el-date-picker
              style="width: 90%"
              v-model="pointFilterBody.createDate.fromDate"
              value-format="timestamp"
              type="date"
              size="mini"
              placeholder="选择日期"
            >
            </el-date-picker>
          </td>

          <td
            v-if="
              pointFilterBody.createDate.dateType == 1 ||
              pointFilterBody.createDate.dateType == 3 ||
              pointFilterBody.createDate.dateType == 4
            "
            style="width: 15%"
          ></td>

          <td v-if="pointFilterBody.createDate.dateType == 7" style="width: 15%">
            <span>至</span>
            <el-date-picker
              style="width: 90%"
              v-model="pointFilterBody.createDate.toDate"
              value-format="timestamp"
              type="date"
              size="mini"
              placeholder="选择日期"
            >
            </el-date-picker>
          </td>

          <td v-if="pointFilterBody.createDate.dateType == 14" style="width: 12%">
            <span>在</span>
            <el-input-number
              v-model="pointFilterBody.createDate.nowDay"
              :min="1"
              size="mini"
            ></el-input-number>
            <span>天</span>
          </td>
          <td v-if="pointFilterBody.createDate.dateType == 14" style="width: 18%">
            <el-select v-model="pointFilterBody.createDate.nowType" size="mini">
              <el-option label="以内" :value="0"> </el-option>
              <el-option label="以外" :value="1"> </el-option>
            </el-select>
          </td>

          <td style="width: 7%">
            <el-button
              type="primary"
              @click="onSearch"
              size="mini"
              style="float: right"
              >检索</el-button
            >
          </td>
          <td style="width: 7%">
            <el-button
              @click="resetPointFilterBody"
              size="mini"
              style="float: left"
              >清除</el-button
            >
          </td>
          <td style="width: 36%"></td>
        </tr>
      </table>
    </div>

    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="userPointList"
        stripe
        border
        :height="tableHeight"
        style="width: 100%"
      >
        <el-table-column
          sortable
          prop="consumeSerialNo"
          label="消费序列号"
          width="175"
          fixed
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="userID"
          label="UserID"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="openID"
          label="OpenID"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="unionID"
          label="UnionID"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="groupID"
          label="积分组"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ getPointGroupName(scope.row.groupID) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="point"
          label="消费积分"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="eventID"
          label="事件类型"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ getEventTypeName(scope.row.eventID) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="consumeType"
          label="消费渠道"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ getConsumeTypeName(scope.row.consumeType) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createDate"
          label="消费日期"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="comment"
          label="备注说明"
          width="300"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination
        :pagesizeList="pageConfig.pagesizeList"
        :pagesize="sendData.pageConfig.pagesize"
        :total="pageConfig.total"
        :page="sendData.pageConfig.page"
      ></pagination>
    </div>

    <a :href="url" style="display: none" ref="aclick"></a>
  </div>
</template>

<script>
import pagination from "@/components/pagination/pagination";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import commonUtil from "@/utils/commonUtil";
import eventType from "@/utils/EventType";

export default {
  name: "UserPoint",
  data() {
    return {
      tableHeight: 500,
      uploadData: { appid: 188, fieldgroupid: 0 },

      pointGroupList: [],
      eventTypeOptions: [],

      consumeTypeOptions: [{ value: 1, name: "运营人员扣除" }],

      //   发送的数据
      sendData: {
        appID: 188,
        filterConfig: {},
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {
          order: "",
          prop: "",
        },
      },

      // 分页
      pageConfig: {
        pagesizeList: [5, 20, 50, 100],
        total: null,
      },

      pointFilterBody: {},

      userPointList: [],

      deleteRow: null,
      deleteDialogVisible: false,
      showDateilDrawer: false,

      url: "",
      name: "",

      dateTypeOptions: [
        { label: "不启用", type: 0 },
        { label: "等于", type: 1 },
        { label: "大于", type: 3 },
        { label: "小于", type: 4 },
        { label: "区间", type: 7 },
        { label: "当前时间点", type: 14 },
      ],
    };
  },
  watch: {},
  methods: {
    getConsumeTypeName(consumeType) {
      for (var i = 0; i < this.consumeTypeOptions.length; ++i) {
        if (this.consumeTypeOptions[i].value == consumeType) {
          return this.consumeTypeOptions[i].name;
        }
      }
      return "未定义";
    },

    downloadCsv() {
      rejecthttp(
        true,
        "post",
        "/manage/point/exportpointconsumelist",
        this.sendData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log("download", doc.data.data);
            this.name = doc.data.data;
            this.url = "/rs/exportdownload/bigcsv?handlekey=" + doc.data.data;
            this.openCsv(this.url);
          }
        }
      );
    },

    openCsv(url) {
      this.$confirm("文件导出完成", "提示", {
        confirmButtonText: "下载",
        cancelButtonText: "取消",

        type: "info",
      })
        .then(() => {
          this.$refs.aclick.click();
          this.$message({
            type: "success",
            message: "正在下载!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下载",
          });
        });
    },

    resetPointFilterBody() {
      this.pointFilterBody = {
        consumeSerialNo: null,
        groupID: null,
        point: null,
        eventID: null,
        consumeType: null,
        userID: null,
        openID: null,
        unionID: null,
        createDate: {
          dateType: 0,
          fromDate: "",
          nowDay: 1,
          nowType: 0,
          toDate: "",
        },
      };

      this.onSearch();
    },

    getEventTypeName(eventID) {
      for (var i = 0; i < this.eventTypeOptions.length; ++i) {
        if (this.eventTypeOptions[i].value == eventID) {
          return this.eventTypeOptions[i].name;
        }
      }
      return "未定义";
    },

    getGainTypeName(gainType) {
      for (var i = 0; i < this.gainTypeOptions.length; ++i) {
        if (this.gainTypeOptions[i].value == gainType) {
          return this.gainTypeOptions[i].name;
        }
      }
      return "未定义";
    },

    getPointGroupName(groupID) {
      for (var i = 0; i < this.pointGroupList.length; ++i) {
        if (this.pointGroupList[i].groupid == groupID) {
          return this.pointGroupList[i].name;
        }
      }
      return "未定义";
    },

    onSearch() {
      this.sendData.pageConfig.page = 1;
      this.pageConfig.total = null;
      this.sendData.filterConfig = JSON.parse(
        JSON.stringify(this.pointFilterBody)
      );
      this.refresh();
    },

    handleClose(done) {},

    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/point/pointgrouplist",
        { appid: "188", search: "" },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            // 添加总条数
            this.pointGroupList = doc.data.data;
            this.pointGroupList.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
            });
          }
        }
      );

      rejecthttp(
        true,
        "post",
        "/manage/point/getpointconsumelist",
        this.sendData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log("hakuna matata", doc.data);
            this.userPointList = doc.data.data;

            this.userPointList.forEach((any) => {
              any.createDate = commonUtil.formatDate(any.createDate);
              any.editDate = commonUtil.formatDate(any.editDate);
            });
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );

      if (this.pageConfig.total != null) {
        return;
      }

      rejecthttp(
        true,
        "post",
        "/manage/point/getpointconsumelistcount",
        this.sendData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.pageConfig.total = doc.data.data;
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    paginationChange(pagesize, page, name) {
      this.sendData.pageConfig.page =
        page != -1 ? page : this.sendData.pageConfig.page;
      this.sendData.pageConfig.pagesize =
        pagesize != -1 ? pagesize : this.sendData.pageConfig.pagesize;
      this.refresh();
    },
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;
      console.log(this.tableHeight);

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },

  computed: {
    sessionHeaders() {
      return { dmfsession: this.$store.state.DMFSession };
    },
  },
  created() {
    this.eventTypeOptions = eventType.getData();
    this.resetPointFilterBody();
  },
  components: {
    pagination,
  },
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
.serachSpan {
  width: 7%;
}
.serachText {
  width: 13%;
}
</style>




// WEBPACK FOOTER //
// src/pages/point/userpointconsume.vue